module.exports = __webpack_public_path__ + "static/media/5DPO10.7abd3278.jpg";